import 'jquery';

export const password_strength_meter = {
  update($meter, strength) {
    const $meterMessage = $meter.find('.password-meter-message');

    if (strength === 'weak') {
      $meter.attr('data-strength', 'weak');
      $meterMessage.text($meterMessage.data('weak'));
    } else if (strength === 'normal') {
      $meter.attr('data-strength', 'normal');
      $meterMessage.text($meterMessage.data('normal'));
    } else if (strength === 'strong') {
      $meter.attr('data-strength', 'strong');
      $meterMessage.text($meterMessage.data('strong'));
    }
  },
};
